const {jQuery: $} = window;
import Utils from "./utils.class";
import InPageNav from "./inPageNav.class";
import TabsLayout from "./layouts/tabs";
import PeopleGrid from "./layouts/people_grid";
import Featherlight from "./../lib/featherlight";
import Cookies from 'js-cookie';
import PieChartCounter from "./components/PieChartCounter.class";
import Hubspot from "./Hubspot.class";
import Complianz from "./Complianz.class";

export default class Theme {
    #main;
    #html;
    #body;
    #header;
    #builder;
    #inPageNav;
    #config;
    #scrollOffset;
    #scrollSpeed;
    
    #utils;
    #admin;
    #root;
    

    constructor(
        config,
        builder,
        utils,
        slider
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.#html = $('html');

        this.#body = $('body');
        this.#header = $('header.site_header');
        this.#admin = $('#wpadminbar');
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#admin = $('#wpadminbar');
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }
    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#admin.length > 0) {
            return this.#header.outerHeight() + this.#admin.outerHeight();
        }

        return this.#header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        if (this.#inPageNav.isActive) {
            subNav = this.#inPageNav.height;
        }

        return this.#scrollOffset + this.headerHeight + subNav;
    }
    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}